import { IPaymentProvidersState } from '../../types/reducers/paymentProviders';

export const defaultState: IPaymentProvidersState = {
  mainProvider: null,
  sbpProvider: null,
};

export function paymentProvidersReducer(state: IPaymentProvidersState) {
  return state || defaultState;
}
